module.exports = __webpack_public_path__ + "transactions.png?fde0f8a15218bcb4cf398496f51dbb13";